import React, { useState } from 'react';
import { testimonials } from '../mock';
import { Card, CardContent } from './ui/card';
import { ChevronLeft, ChevronRight, Star, Quote } from 'lucide-react';
import { Button } from './ui/button';

export const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const next = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section id="temoignages" className="py-24 bg-gradient-to-br from-[#153254] to-[#122b26] text-white relative overflow-hidden scroll-mt-40">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-72 h-72 bg-[#D4AF37] rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#D4AF37] rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="mb-12">
          <h2 className="text-5xl font-bold mb-4 text-white">L'expérience The MajordHome</h2>
          <p className="text-xl text-white/90 mb-6">À travers vos mots</p>
          
          <div className="flex items-center gap-3 mt-6 flex-wrap">
            <div className="text-5xl font-bold">4.8/5</div>
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-[#D4AF37] text-[#D4AF37]" strokeWidth={1.5} />
              ))}
            </div>
          </div>
          <p className="text-sm text-white/80 mt-3 font-medium">Avis certifiés Google</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Card className="bg-white/10 backdrop-blur-xl border-2 border-white/20 shadow-2xl">
            <CardContent className="p-8 md:p-12 relative">
              <Quote className="absolute top-4 left-4 h-16 w-16 text-[#D4AF37] opacity-30" />
              
              <div className="text-center mb-6 relative z-10">
                {/* Photo réelle du client */}
                <div className="mb-4">
                  <div className="w-20 h-20 rounded-full overflow-hidden border-4 border-[#D4AF37] shadow-lg mx-auto">
                    <img 
                      src={currentTestimonial.avatar} 
                      alt={currentTestimonial.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div className="flex justify-center gap-0.5 mb-4">
                  {[...Array(currentTestimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-[#D4AF37] text-[#D4AF37]" strokeWidth={1.5} />
                  ))}
                </div>
                <p className="text-xl md:text-2xl italic mb-6 leading-relaxed font-light text-white">
                  "{currentTestimonial.comment}"
                </p>
                <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 inline-block">
                  <p className="font-bold text-2xl mb-1 text-white">{currentTestimonial.name}</p>
                  <p className="text-sm text-white/70 mt-1">{currentTestimonial.date}</p>
                  <p className="text-xs text-[#D4AF37] mt-2 font-semibold">Avis vérifié Google</p>
                </div>
              </div>

              <div className="flex justify-center gap-4 mt-8">
                <Button
                  onClick={prev}
                  variant="outline"
                  size="icon"
                  className="bg-white/20 border-2 border-white/40 hover:bg-white/30 text-white backdrop-blur-sm shadow-lg hover:scale-110 transition-transform w-12 h-12"
                >
                  <ChevronLeft className="h-6 w-6" />
                </Button>
                <Button
                  onClick={next}
                  variant="outline"
                  size="icon"
                  className="bg-white/20 border-2 border-white/40 hover:bg-white/30 text-white backdrop-blur-sm shadow-lg hover:scale-110 transition-transform w-12 h-12"
                >
                  <ChevronRight className="h-6 w-6" />
                </Button>
              </div>

              <div className="flex justify-center gap-2 mt-6">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`h-3 rounded-full transition-all ${
                      index === currentIndex ? 'bg-white w-12' : 'bg-white/50 w-3'
                    }`}
                  />
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
